import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IPermissionsDialogForm } from '../PermissionsDialogForm';
import { getPermissionLevelFromFormState } from '../utilities/getPermissionLevelFromFormState';

export function useSetPermissionLevelOnFormStateChange() {
  const { control, setValue } = useFormContext<IPermissionsDialogForm>();
  const formValues = useWatch({ control });

  useEffect(() => {
    const newPermissionLevel = getPermissionLevelFromFormState(formValues as IPermissionsDialogForm);

    if (newPermissionLevel !== formValues.permissionLevel) {
      setValue('permissionLevel', newPermissionLevel, {
        shouldValidate: false,
      });
    }
  }, [formValues, setValue]);
}
